
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationCoordinatingGroups, QueryConfigurationCoordinatingGroupsResponse, ConfigurationCoordinatingGroup } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationCoordinatingGroupsResponse, QueryConfigurationCoordinatingGroupsResponse>) => response?.data?.data?.find(x => true);
const getError = (response?: SWRResponse<QueryConfigurationCoordinatingGroupsResponse, QueryConfigurationCoordinatingGroupsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationCoordinatingGroupsResponse, QueryConfigurationCoordinatingGroupsResponse>) => ({});

export const useConfigurationCoordinatingGroup = (query?: Partial<ConfigurationCoordinatingGroup>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationCoordinatingGroups(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationCoordinatingGroup;